import { safeGet, safeSet } from "@/components/onboarding/safe-storage";

const SNOOZE_MS = 14 * 86_400_000;

const snoozeKey = (userId: string) => `upsider_push_prompt:${userId}:snoozed_at`;

export function isPushPromptSnoozed(userId: string): boolean {
  return Date.now() - Number(safeGet(snoozeKey(userId))) < SNOOZE_MS;
}

export function snoozePushPrompt(userId: string): void {
  safeSet(snoozeKey(userId), String(Date.now()));
}
